import React, { useMemo } from 'react';
import CensusStatistics from 'components/common/census/census-review/CensusStatistics';
import { observer } from 'mobx-react-lite';
import PageHeader from 'components/common/census/census-review/PageHeader';
import useGroupQuoteUrlParams from 'global/hooks/useGroupQuoteUrlParams';
import CensusStatisticsMonitorAddEePageStore, {
  CensusStatisticsMonitorAddEePageStoreContext,
  useCensusStatisticsMonitorAddEePageStore,
} from 'store/pages/rfq/census-stats-monitor-add-employees/pageStore';
import { NarrowPageWrapperStyled } from '../../../globalStyles';

/* TESTING_POLICY: CYPRESS_ONLY */

const PageContent: React.FC = observer(() => {
  const pageStore = useCensusStatisticsMonitorAddEePageStore();
  return (
    <>
      <PageHeader pageStore={pageStore} />
      <CensusStatistics pageStore={pageStore} />
    </>
  );
});

const CensusMonitorAddEeReviewPage: React.FC = () => {
  const { periodId, groupId, cartId } = useGroupQuoteUrlParams();
  const pageStore = useMemo(
    () => new CensusStatisticsMonitorAddEePageStore({ enrollmentPeriodId: periodId, groupId, cartId }),
    [],
  );

  return (
    <CensusStatisticsMonitorAddEePageStoreContext.Provider value={pageStore}>
      <NarrowPageWrapperStyled>
        <PageContent />
      </NarrowPageWrapperStyled>
    </CensusStatisticsMonitorAddEePageStoreContext.Provider>
  );
};

export default CensusMonitorAddEeReviewPage;
